import { UserProfile } from '__generated__/GQL';

// 50% (8/16) of users will be in the experiment
const ACCEPTED_LAST_CHARS = new Set<string>([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
]);

/**
 * This experiment is only for micro-companies.
 * Companies in the experiment sample will be asked to complete 3 steps in the onboarding
 * hub which are completed before or after for companies in the base sample:
 *  - company financial info (compliance questions only for micro)
 *  - CGU signature
 *  - price plan selection
 *
 * @see https://shinetools.slack.com/archives/C06L7464DCY/p1716907278220939
 */
const getIsUserInExperiment = (
  userProfile: Pick<UserProfile, 'email' | 'uid'>,
) => {
  const { email, uid } = userProfile;

  if (!email) {
    return false;
  }

  if (email.includes('obhubmicroexpin')) {
    return true;
  } else if (email.includes('obhubmicroexpout')) {
    return false;
  }

  const lastChar = uid[uid.length - 1] ?? '';

  return ACCEPTED_LAST_CHARS.has(lastChar);
};

const onboardingHubMicroExperiment = {
  getIsUserInExperiment,
};

export default onboardingHubMicroExperiment;
